import { render, staticRenderFns } from "./OurProposals.vue?vue&type=template&id=687bc33a"
import script from "./OurProposals.vue?vue&type=script&lang=js"
export * from "./OurProposals.vue?vue&type=script&lang=js"
import style0 from "./OurProposals.vue?vue&type=style&index=0&id=687bc33a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports